<template>
  <div v-if="hasTariffs">
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="false"
        :refurbishedHighlights="false"
        :contentPageOnly="false"
        :title="'Telekom - Tarifangebote'"
        :store="currentStore"
        :allMobile="true"
        :mobile="true"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="false"
        :refurbishedHighlights="true"
        :contentPageOnly="false"
        :title="'Telekom - Refurbished Highlights'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="true"
        :contentPageOnly="false"
        :title="'Studenten - Tarifangebote'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="true"
        :student="false"
        :contentPageOnly="false"
        :title="'Telekom - Vertragsverlängerungsangebote'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
  </div>
  <h1
    v-else
    class="pt-12 pb-12 container mx-auto font-bold text-paragraph text-2xl text-center"
  >
    Aktuell gibt es keine laufenden Telekom Tarifangebote
  </h1>
</template>

<script setup lang="ts">
import { hasTenantTariffs } from "~/composables/tariffs";

useHead({
  title: "Telekom Tarifangebote - Die besten MagentaMobil-Deals in Ihrer Nähe",
  meta: [
    {
      name: "description",
      content:
        "Entdecken Sie exklusive Telekom Tarifangebote mit Smartphone-Bundles, 5G-Highspeed und Aktionsrabatten. Jetzt MagentaMobil-Deals sichern und beraten lassen.",
    },
  ],
});

const tenantId: string = "692ef56ad1b19b630ac62ff3"; // TODO: Dynamic [slug].vue
const currentStore = useCurrentStore();
const hasTariffs = ref<boolean>();

const checkHasTariffs = async (storeId: string): Promise<void> => {
  hasTariffs.value = await hasTenantTariffs(tenantId, storeId, {contentPageOnly: false});
};

await checkHasTariffs(currentStore.value?.id);

watch(currentStore, async (store) => {
  const storeId: string = store?.id;
  if (!storeId) {
    return;
  }

  await checkHasTariffs(storeId);
});
</script>
